// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';
import {
    ClearAll,
    Configure,
    InstantSearch,
    Pagination,
    RefinementList,
    Stats,
} from 'react-instantsearch/dom';

import Scrollable from '../../components/shared/Scrollable';
import Loader from '../../components/Loader/Loader';
import RangeSlider from '../../components/ConnectedRange/ConnectedRange';

import AddRemoveToLetBoardModal from '../../components/PropertyForms/AddRemoveToLetBoardModal';
import DeletePropertyModal from '../../components/PropertyForms/DeletePropertyModal';
import DuplicatePropertyModal from '../../components/PropertyForms/DuplicatePropertyModal';
import ExportListModal from '../../components/PropertyForms/ExportListModal';

import PropertySearchList from './PropertySearchList';
import PropertySearchBox from './PropertySearchBox';

import {
    deletePromptEnteredReferenceChange,
    deletePromptReset,
    removeProperty,
    duplicatePromptEnteredReferenceChange,
    duplicatePromptReset,
    duplicateProperty,
    exportPromptShow,
    exportGenerate,
    exportPromptReset,
    toLetBoardSubmit,
    toLetBoardReset,
} from '../../redux/reducers/property';

import { loadContacts } from '../../redux/reducers/contacts';
import { getContacts } from '../../selectors/shared';
import '../PropertySearch/PropertySearch.css';
import { getFormValue, getFormAssetId } from '../../shared/utils';

const transformStatusFacets = facets => {
    const propertyStatusLookup = {
        AVAILABLE: 'Available',
        UNDER_OFFER: 'Under Offer',
        HIDE: 'Hide',
        NOW_LET: 'Now Let',
    };

    return facets.map(facet => {
        return Object.assign({}, facet, {
            label: propertyStatusLookup[facet.label],
        });
    });
};

const Search = ({ onExportListClick, onToLetBoardClick }) => {
    return (
        <div className="PropertySearch-wrapper">
            <div className="PropertySearch-search">
                <div className="PropertySearch-search--wrapper">
                    <div className="pin-top">
                        <div className="search-section">
                            <Link
                                className="PropertySearch-add-btn"
                                to="/property/add"
                            >
                                Add New Property
                            </Link>
                        </div>

                        <PropertySearchBox />
                    </div>

                    <Scrollable additionalClassName="filters">
                        <div className="search-section">
                            <h4>Rent</h4>
                            <RangeSlider
                                attributeName="PropertyRent"
                                label="Rent"
                                formatValue={val => {
                                    return `£${parseInt(
                                        val,
                                        10
                                    ).toLocaleString()}`;
                                }}
                            />
                        </div>

                        <div className="search-section">
                            <h4>Size</h4>
                            <RangeSlider
                                attributeName="PropertySize"
                                label="Size"
                                formatValue={val => {
                                    return `${parseInt(
                                        val,
                                        10
                                    ).toLocaleString()} sq ft`;
                                }}
                            />
                        </div>

                        <div className="search-section">
                            <h4>Property Type</h4>
                            <RefinementList attributeName="PropertyTypes" />
                        </div>

                        <div className="search-section">
                            <h4>Business Estate</h4>
                            <RefinementList attributeName="PropertyBusinessEstate" />
                        </div>

                        <div className="search-section">
                            <h4>Status</h4>
                            <RefinementList
                                attributeName="PropertyStatus"
                                transformItems={transformStatusFacets}
                            />
                        </div>
                    </Scrollable>

                    <div className="stats">
                        <div className="stats-wrapper">
                            <Stats />
                            <ClearAll />
                        </div>
                    </div>
                </div>
            </div>

            <div className="PropertySearch-list">
                <div className="PropertySearch-list-wrapper">
                    <PropertySearchList />
                </div>

                <div className="PropertySearch-list--pagination">
                    <Pagination />
                    <button
                        className="PropertySearch-export-btn"
                        onClick={onExportListClick}
                    >
                        Export Properties
                    </button>
                </div>
            </div>
        </div>
    );
};

class PropertySearch extends Component {
    confirmDelete: Function;
    deletePromptReset: Function;
    deletePromptRefChanged: Function;

    confirmDuplicate: Function;
    duplicatePromptReset: Function;
    duplicatePromptRefChanged: Function;
    onSearchStateChange: Function;
    onExportListClick: Function;
    onExportListSubmit: Function;
    onExportListCancel: Function;

    onToLetBoardSubmit: Function;
    onToLetBoardCancel: Function;

    refresh: Function;

    state = {
        refreshing: false,
        searchState: null,
    };

    constructor(props) {
        super(props);

        this.confirmDelete = this.confirmDelete.bind(this);
        this.deletePromptReset = this.deletePromptReset.bind(this);
        this.deletePromptRefChanged = this.deletePromptRefChanged.bind(this);

        this.confirmDuplicate = this.confirmDuplicate.bind(this);
        this.duplicatePromptReset = this.duplicatePromptReset.bind(this);
        this.duplicatePromptRefChanged = this.duplicatePromptRefChanged.bind(
            this
        );

        this.refresh = this.refresh.bind(this);
        this.onSearchStateChange = this.onSearchStateChange.bind(this);
        this.onExportListClick = this.onExportListClick.bind(this);
        this.onExportListSubmit = this.onExportListSubmit.bind(this);
        this.onExportListCancel = this.onExportListCancel.bind(this);

        this.onToLetBoardSubmit = this.onToLetBoardSubmit.bind(this);
        this.onToLetBoardCancel = this.onToLetBoardCancel.bind(this);
    }

    componentDidMount() {
        this.props.dispatch(loadContacts(1, 9999));
    }

    confirmDelete() {
        const {
            dispatch,
            deletePrompt: { propertyId, propertyReference },
        } = this.props;

        dispatch(removeProperty(propertyId, propertyReference)).then(() => {
            this.refresh();
        });
    }

    deletePromptRefChanged(value) {
        this.props.dispatch(deletePromptEnteredReferenceChange(value));
    }

    deletePromptReset() {
        this.props.dispatch(deletePromptReset());
    }

    confirmDuplicate() {
        const {
            dispatch,
            duplicatePrompt: { propertyId, enteredReference },
            history,
        } = this.props;

        dispatch(
            duplicateProperty(propertyId, enteredReference)
        ).then(response => {
            if (response === 'success') {
                history.push(`/property/edit/${enteredReference}`);
            }
        });
    }

    duplicatePromptRefChanged(value) {
        this.props.dispatch(duplicatePromptEnteredReferenceChange(value));
    }

    duplicatePromptReset() {
        this.props.dispatch(duplicatePromptReset());
    }

    onSearchStateChange(searchState) {
        this.setState({
            searchState,
        });
    }

    onExportListClick() {
        this.props.dispatch(exportPromptShow(this.state.searchState));
    }

    onExportListSubmit(formValues) {
        const { contactId, format } = formValues;

        this.props.dispatch(exportGenerate(contactId, format));
    }

    onExportListCancel() {
        this.props.dispatch(exportPromptReset());
    }

    onToLetBoardSubmit(formValues) {
        const geolocation = getFormValue(formValues, 'geolocation');

        const data = {
            toLetBoardPropertyId: getFormValue(formValues, 'propertyId'),
            toLetBoardInstruction: getFormValue(formValues, 'instructionType'),
            toLetBoardBoardType: getFormValue(formValues, 'boardType'),
            toLetBoardPlacement: getFormValue(formValues, 'boardPlacement'),
            toLetBoardAdditionalWording: getFormValue(
                formValues,
                'additionalWording'
            ),
            toLetBoardFixingInstructions: getFormValue(
                formValues,
                'specificFixingInstructions'
            ),
            toLetBoardKeyRequire:
                getFormValue(formValues, 'keyRequired') === 'YES',
            toLetBoardKeyRequireText: getFormValue(formValues, 'keyDetails'),
            toLetBoardLat: geolocation ? geolocation.lat : null,
            toLetBoardLong: geolocation ? geolocation.lng : null,
            toLetBoardLocationDescription: getFormValue(
                formValues,
                'locationDescription'
            ),
            toLetPhotoAssetId: getFormAssetId(formValues, 'photoAsset'),
        };

        return this.props.dispatch(toLetBoardSubmit(data));
    }

    onToLetBoardCancel() {
        this.props.dispatch(toLetBoardReset());
    }

    refresh() {
        this.setState({
            refreshing: true,
        });

        setTimeout(() => {
            this.setState({
                refreshing: false,
            });
        }, 500);
    }

    render() {
        const {
            algoliaSettings,
            contactList,
            deletePrompt,
            duplicatePrompt,
            exportPrompt,
            toLetBoardPrompt,
        } = this.props;
        const { refreshing } = this.state;

        return (
            <div>
                <DeletePropertyModal
                    isOpen={deletePrompt.visible}
                    removing={deletePrompt.removing}
                    propertyReference={deletePrompt.propertyReference}
                    enteredReference={deletePrompt.enteredReference}
                    onCancel={this.deletePromptReset}
                    onConfirmDelete={this.confirmDelete}
                    onEnteredReference={this.deletePromptRefChanged}
                />

                <DuplicatePropertyModal
                    isOpen={duplicatePrompt.visible}
                    duplicating={duplicatePrompt.duplicating}
                    propertyReference={duplicatePrompt.propertyReference}
                    enteredReference={duplicatePrompt.enteredReference}
                    onCancel={this.duplicatePromptReset}
                    onConfirmDuplicate={this.confirmDuplicate}
                    onEnteredReference={this.duplicatePromptRefChanged}
                />

                <ExportListModal
                    contactList={contactList}
                    isOpen={exportPrompt.visible}
                    exportState={exportPrompt}
                    onCancel={this.onExportListCancel}
                    onGenerate={this.onExportListSubmit}
                />

                <AddRemoveToLetBoardModal
                    isOpen={toLetBoardPrompt.visible}
                    data={toLetBoardPrompt}
                    onCancel={this.onToLetBoardCancel}
                    onSubmit={this.onToLetBoardSubmit}
                />

                {refreshing && <Loader message="Refreshing, please wait..." />}

                {!refreshing &&
                    <InstantSearch
                        appId={algoliaSettings.appId}
                        apiKey={algoliaSettings.searchApiKey}
                        indexName={algoliaSettings.indices.admin}
                        onSearchStateChange={this.onSearchStateChange}
                    >
                        <Configure typoTolerance={false} />
                        <Search onExportListClick={this.onExportListClick} />
                    </InstantSearch>}
            </div>
        );
    }
}

const mapStateToProps = state => {
    const duplicate = state.property.duplicate;
    const toLetBoard = state.property.toLetBoard;
    const remove = state.property.remove;

    return {
        deletePrompt: {
            propertyId: remove.propertyId,
            propertyReference: remove.propertyReference,
            enteredReference: remove.enteredReference,
            removing: remove.removing,
            visible: Boolean(remove.propertyId && remove.propertyReference),
        },
        duplicatePrompt: {
            propertyId: duplicate.propertyId,
            propertyReference: duplicate.propertyReference,
            enteredReference: duplicate.enteredReference,
            duplicating: duplicate.duplicating,
            visible: Boolean(
                duplicate.propertyId && duplicate.propertyReference
            ),
        },
        exportPrompt: state.property.export,
        contactList: getContacts(state),
        toLetBoardPrompt: {
            visible: toLetBoard.visible === true,
            propertyReference: toLetBoard.propertyReference,
            saving: toLetBoard.saving,
            saved: toLetBoard.saved,
            property: {
                fetching: state.property.detail.fetching,
                detail: state.property.detail.property,
            },
        },
        algoliaSettings: state.shared.settings.algolia,
    };
};

export default withRouter(connect(mapStateToProps)(PropertySearch));



// WEBPACK FOOTER //
// ./src/containers/PropertySearch/PropertySearch.js